import React from "react";
import styles from "./PlaydateInviteBaseUnit.module.css";
import locationIcon from "../../assets/icons/locationIcon.svg";
import dateIcon from "../../assets/icons/dateIcon.svg";
import timeIcon from "../../assets/icons/timeIcon.svg";
import { PlaydateInvite, InviteStatus } from "../../gql/types";
import { formatFinalScheduleOption, formatFirstScheduleOption } from "./formatter";

interface Props {
    invite: PlaydateInvite;
}

const PlaydateInviteDetails: React.FC<Props> = ({ invite }) => {
    let date: string;
    let time: string;

    if (invite.status === InviteStatus.Confirmed) {
        const { date: optionDate, time: optionTime } = formatFinalScheduleOption(invite.finalScheduleOption);
        date = optionDate;
        time = optionTime;
    } else {
        const { date: optionDate, time: optionTime } = formatFirstScheduleOption(invite.scheduleOptions);
        date = optionDate;
        time = optionTime;
    }

    return (
        <div className={styles.detailsContainer}>
            <div className={styles.titleRow}>{invite.title}</div>
            <div className={styles.locationRow}>
                <img src={locationIcon} className={styles.detailsIcon} />
                <span>{invite.location ?? "TBD"}</span>
            </div>
            <div className={styles.timeRow}>
                <div className={styles.dateDetail}>
                    <img src={dateIcon} className={styles.detailsIcon} />
                    <span>{date}</span>
                </div>
                <div className={styles.timeDetail}>
                    <img src={timeIcon} className={styles.detailsIcon} />
                    <span>{time}</span>
                </div>
            </div>
        </div>
    );
};

export default PlaydateInviteDetails;
